webpackJsonp([1],{

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(266)
}
var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(286),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_views_header_vue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_views_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_views_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_views_calculator_vue__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_views_calculator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_views_calculator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_views_result_vue__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_views_result_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_views_result_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_views_savings_vue__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_views_savings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_views_savings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_views_printHeader_vue__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_views_printHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_views_printHeader_vue__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Libraries


// Components






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      printing: false,
      loaded: false, // Data must be fetched for rendering dependent components
      type: 'gasPrice', // Type gas/diesel
      chosenCompanies: ['Tanka'],
      companies: [{
        website: 'http://www.tanka.se/',
        logotype: __webpack_require__(275),
        name: 'Tanka',
        data: {}
      }, {
        website: 'https://www.okq8.se/foretag/priser/#/',
        logotype: __webpack_require__(272),
        name: 'OKQ8',
        data: {}
      },
      /*
      {
        website: 'https://',
        logotype: require('assets/images/logos/shell.png'),
        name: 'Shell',
        data: {}
      },
      */
      {
        website: 'https://www.circlek.se/foretag/drivmedel/drivmedelspriser',
        logotype: __webpack_require__(271),
        name: 'Circle K',
        data: {}
      }, {
        website: 'https://www.preem.se/foretag/kund-hos-preem/listpriser/listpriser-foretagskort/',
        logotype: __webpack_require__(274),
        name: 'Preem',
        data: {}
      }, {
        logotype: __webpack_require__(273),
        name: 'Other',
        data: {
          gasPrice: 0,
          dieselPrice: 0,
          gasPriceList: 0,
          dieselPriceList: 0,
          invoiceDiscount: 0,
          cardDiscount: 0
        }
      }],
      savings: {
        mileage: 2500,
        cars: 1,
        price: 0
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var that = this;

    // Get API data and insert data to every company
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://volvofinans.fbinhouse.se/vfin-drivmedelsguiden-api-q2-2017/api').then(function (response) {
      response.data.forEach(function (x) {
        that.companies.forEach(function (y, i) {
          if (y.name === x['namn']) {
            // Use Vue $set method to make new object properties reactive
            that.$set(that.companies[i].data, 'gasPrice', parseFloat(x['bensin_pris'].replace(',', '.')));
            that.$set(that.companies[i].data, 'dieselPrice', parseFloat(x['diesel_pris'].replace(',', '.')));
            that.$set(that.companies[i].data, 'gasPriceList', parseFloat(x['bensin_pris_list'].replace(',', '.')));
            that.$set(that.companies[i].data, 'dieselPriceList', parseFloat(x['diesel_pris_list'].replace(',', '.')));
            that.$set(that.companies[i].data, 'invoiceDiscount', -window.Math.abs(parseInt(x['faktura_rabatt']) / 100));
            that.$set(that.companies[i].data, 'cardDiscount', -window.Math.abs(parseInt(x['kort_rabatt']) / 100));
          }
          // When loaded, tell child components to render
          that.loaded = true;
        });
      });

      var urls = _this.getUrlVars();
      if (urls.print) {
        var data = JSON.parse(window.decodeURIComponent(urls.data));
        _this.printing = true;
        if (data.type) {
          _this.type = data.type;
        }
        if (data.chosenCompanies) {
          _this.chosenCompanies = data.chosenCompanies;
        }
        if (data.companies) {
          _this.companies = data.companies;
        }
        if (data.savings) {
          _this.savings = data.savings;
        }
      }
    }).catch(function (response) {
      console.warn('Could not fetch data, is API running?\n', response);
    });

    if (window.innerWidth < 800 && this.chosenCompanies.length <= 1) {
      this.chosenCompanies.push(this.companies[1].name);
    }

    window.addEventListener('resize', function (e) {
      if (e.target.innerWidth < 800 && _this.chosenCompanies.length <= 1) {
        _this.chosenCompanies.push(_this.companies[1].name);
      }
    }, false);
  },

  methods: {
    getUrlVars: function getUrlVars() {
      var hash = void 0;
      var myJson = {};
      var hashes = window.location.search.slice(window.location.search.indexOf('?') + 1).split('&');
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        myJson[hash[0]] = hash[1];
      }
      return myJson;
    },
    updateSavings: function updateSavings(obj) {
      this.savings[obj.name] = obj.value;
    },
    sendToPrinting: function sendToPrinting() {
      var data = {};
      data.type = this.type;
      data.chosenCompanies = this.chosenCompanies;
      data.companies = this.companies;
      data.savings = this.savings;
      // const string = window.location.toString() + '?print=true&data=' + window.encodeURIComponent(JSON.stringify(data))
      // window.location.href = string
      window.open('http://pdf.fbinhouse.se/generate?url=' + window.encodeURIComponent(window.location.toString() + '?print=true&data=' + window.encodeURIComponent(JSON.stringify(data))), '_blank');
    },
    updatePrice: function updatePrice(event, company, type) {
      var that = this;
      this.companies.forEach(function (x, i) {
        if (x.name === company) {
          that.$set(that.companies[i].data, type, parseFloat(event.target.value));
        }
      });
    },
    updateType: function updateType(value) {
      this.type = value;
    },
    updateDiscount: function updateDiscount(value, type, company) {
      var that = this;
      var val = parseFloat(parseInt(value) / 100);
      if (!val) {
        val = 0;
      }
      this.companies.forEach(function (x, i) {
        if (x.name === company) {
          that.$set(that.companies[i].data, type, val);
        }
      });
    },
    handleCompany: function handleCompany(value) {
      if (this.chosenCompanies.includes(value)) {
        this.chosenCompanies = [].concat(_toConsumableArray(this.chosenCompanies.slice(0, this.chosenCompanies.indexOf(value))), _toConsumableArray(this.chosenCompanies.slice(this.chosenCompanies.indexOf(value) + 1)));
        return;
      }

      this.chosenCompanies.push(value);
    },
    handleOnlyThisCompany: function handleOnlyThisCompany(value) {
      this.chosenCompanies = ['Tanka', value];
    }
  },
  computed: {
    selectedCompanies: function selectedCompanies() {
      var that = this;
      return that.companies.filter(function (x) {
        return that.chosenCompanies.includes(x.name);
      });
    }
  },
  components: {
    dgHeader: __WEBPACK_IMPORTED_MODULE_1_components_views_header_vue___default.a,
    dgCalculator: __WEBPACK_IMPORTED_MODULE_2_components_views_calculator_vue___default.a,
    dgResult: __WEBPACK_IMPORTED_MODULE_3_components_views_result_vue___default.a,
    dgSavings: __WEBPACK_IMPORTED_MODULE_4_components_views_savings_vue___default.a,
    dgPrintHeader: __WEBPACK_IMPORTED_MODULE_5_components_views_printHeader_vue___default.a
  }
});

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_scrollDown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sizzle__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sizzle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sizzle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_wnumb__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_wnumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_wnumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_question_circle__ = __webpack_require__(259);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    companies: {
      type: Array
    },
    chosenCompanies: {
      type: Array
    },
    type: {
      type: String
    },
    printing: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      target: null,
      showListPris: false,
      showSkyltatPris: false
    };
  },
  mounted: function mounted() {
    this.target = __WEBPACK_IMPORTED_MODULE_1_sizzle___default()('.result')[0];
  },

  filters: {
    toFixed: function toFixed(value) {
      if (Number(value) === value && value % 1 !== 0) {
        return value.toFixed(2);
      }
      return value;
    },
    normalize: function normalize(value) {
      var formatter = __WEBPACK_IMPORTED_MODULE_2_wnumb___default()({
        mark: ',',
        thousand: ' ',
        decimals: 2
      });
      return formatter.to(value);
    }
  },
  methods: {
    setDecimal: function setDecimal(el) {
      el.value = parseFloat(el.value).toFixed(2);
    },
    scrollDown: function scrollDown() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lib_scrollDown__["a" /* default */])(this.target.offsetTop);
    },

    // Calculate total prices
    calculateTotal: function calculateTotal(company) {
      var _this = this;

      var val = parseFloat(0);
      this.companies.forEach(function (x) {
        if (x.name === company) {
          val = (x.name === 'Tanka' ? x.data[_this.type] : x.data[_this.type + 'List']) + x.data.invoiceDiscount + x.data.cardDiscount;
          // val = x.data[this.type] + x.data.invoiceDiscount + x.data.cardDiscount
        }
      });
      return val;
    },

    // Converts discount from decimal to base 10
    convertDiscount: function convertDiscount(discount) {
      var val = parseInt(discount * 100);
      if (val > 0) {
        return '-' + val;
      }

      return val;
    },
    convertPrice: function convertPrice(price) {
      var val = parseFloat(price);
      if (val > 0) {
        return val.toFixed(2);
      }

      return val;
    },

    // Calculate both discounts, and converts to a positive number
    calculatedDiscounts: function calculatedDiscounts(company) {
      var val = 0;
      this.companies.forEach(function (x) {
        if (x.name === company) {
          val = x.data.invoiceDiscount + x.data.cardDiscount;
        }
      });
      val = this.convertDiscount(window.Math.abs(val));
      if (val !== 0) {
        val = '+' + val;
      }

      return val.toString().replace('-', '');
    },

    // Appends or removes a company from chosenCompanies array
    fixateTarget: function fixateTarget(value) {
      this.$emit('handleCompany', value);
    },
    fixateOnlyThisTarget: function fixateOnlyThisTarget(value) {
      this.$emit('handleOnlyThisCompany', value);
    }
  },
  watch: {
    type: function type() {
      this.$emit('updateType', this.type);
    }
  }
});

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_scrollDown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sizzle__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sizzle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sizzle__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      target: null
    };
  },
  mounted: function mounted() {
    this.target = __WEBPACK_IMPORTED_MODULE_1_sizzle___default()('.calculator')[0];
  },

  methods: {
    scrollDown: function scrollDown() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lib_scrollDown__["a" /* default */])(this.target.offsetTop);
    }
  }
});

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    date: function date() {
      var dt = new Date();
      var month = dt.getMonth();
      var day = dt.getDate();
      if (month.toString().length === 1) {
        month = '0' + month;
      }

      if (day.toString().length === 1) {
        day = '0' + day;
      }

      return dt.getFullYear() + '-' + month + '-' + day;
    }
  }
});

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_velocity_animate__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_velocity_animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scrollmonitor__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scrollmonitor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_scrollmonitor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sizzle__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sizzle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sizzle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_scrollDown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_odometer__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_odometer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_odometer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_wnumb__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_wnumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_wnumb__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    companies: {
      type: Array
    },
    type: String,
    chosen: Array
  },
  data: function data() {
    return {
      highValue: 0.00,
      lowValue: 0.00,
      target: null
    };
  },

  filters: {
    normalize: function normalize(value) {
      var formatter = __WEBPACK_IMPORTED_MODULE_5_wnumb___default()({
        mark: ',',
        thousand: ' '
      });
      return formatter.to(value);
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1_scrollmonitor___default.a.recalculateLocations();
    this.target = __WEBPACK_IMPORTED_MODULE_2_sizzle___default()('.savings')[0];
  },

  methods: {
    scrollDown: function scrollDown() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lib_scrollDown__["a" /* default */])(this.target.offsetTop);
    },

    // Calculation to see how many pixels the chart needs in height
    calculate: function calculate(value) {
      var height = __WEBPACK_IMPORTED_MODULE_2_sizzle___default()('.chart-column-container', this.$el)[0].clientHeight;
      var pxPerCent = height / ((this.highValue - this.lowValue) * 100);
      return parseInt((value - this.lowValue) * 100 * pxPerCent);
    },
    increaseHeight: function increaseHeight(element, watcher, value, odElement) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default()(element, {
        height: that.calculate(value)
      }, {
        duration: 1500,
        begin: function begin() {
          odElement.update(value + 100 + 0.001);
        },
        progress: function progress(element, complete, remaining, start, tweenValue) {},
        complete: function complete() {
          watcher.recalculateLocation();
        }
      });
    },
    resetHeight: function resetHeight(element, watcher, odElement) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default()(element, {
        height: 20
      }, {
        complete: function complete() {
          odElement.update(_this.lowValue);
          watcher.recalculateLocation();
        }
      });
    }
  },
  directives: {
    scroll: {
      inserted: function inserted(el, binding, vnode) {
        // Bind vue instance to that constant
        var that = vnode.context;
        // Create a watcher with scrollMonitor library
        var watcher = __WEBPACK_IMPORTED_MODULE_1_scrollmonitor___default.a.create(el);

        var od = new __WEBPACK_IMPORTED_MODULE_4_odometer___default.a({
          el: el.firstChild,
          format: '( ddd),ddd',
          duration: 1000
        });

        // Function when it enters viewport
        watcher.enterViewport(function () {
          if (el.offsetParent === null) {
            return;
          }

          var company = that.companies.find(function (x) {
            return x.name === el.getAttribute('id');
          });

          var type = that.type;

          if (type === 'dieselPrice') {
            if (company.name === 'Tanka') {
              that.increaseHeight(el, watcher, company.data.dieselPrice + company.data.cardDiscount + company.data.invoiceDiscount, od);
            } else {
              that.increaseHeight(el, watcher, company.data.dieselPriceList + company.data.cardDiscount + company.data.invoiceDiscount, od);
            }
          } else {
            if (company.name === 'Tanka') {
              that.increaseHeight(el, watcher, company.data.gasPrice + company.data.cardDiscount + company.data.invoiceDiscount, od);
            } else {
              that.increaseHeight(el, watcher, company.data.gasPriceList + company.data.cardDiscount + company.data.invoiceDiscount, od);
            }
          }
        });

        // When it exists viewport
        watcher.exitViewport(function () {
          that.resetHeight(el, watcher, od);
        });
      }
    }
  },
  computed: {
    highestPrice: function highestPrice() {
      var that = this;
      if (this.companies.length === 0) {
        return that.highValue;
      }

      that.highValue = 0.00;

      this.companies.forEach(function (x) {
        if (x.data[that.type] > that.highValue) {
          that.highValue = window.Math.ceil(x.data[that.type]);
        }
      });

      return that.highValue;
    },
    lowestPrice: function lowestPrice() {
      var that = this;
      if (this.companies.length === 0) {
        return that.lowValue;
      }

      that.lowValue = 0.00;

      this.companies.forEach(function (x) {
        var totValue = x.data[that.type] + x.data.cardDiscount + x.data.invoiceDiscount;
        if ((totValue < that.lowValue || that.lowValue === 0.00) && x.data[that.type] !== 0) {
          that.lowValue = window.Math.floor(totValue);
        }
      });

      return that.lowValue;
    }
  }
});

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_progressbar_js__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_progressbar_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_progressbar_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sizzle__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sizzle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sizzle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scrollmonitor__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scrollmonitor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_scrollmonitor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_odometer__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_odometer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_odometer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nouislider__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nouislider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_nouislider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_wnumb__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_wnumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_wnumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lib_scrollDown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_velocity_animate__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_velocity_animate__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    companies: {
      type: Array
    },
    type: String,
    printing: {
      type: Boolean,
      default: false
    },
    savings: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      prg: null,
      od: null,
      sliders: {
        mileage: null,
        price: null,
        cars: null
      },
      timeoutId: null,
      expanded: false,
      target: null
    };
  },

  filters: {
    normalize: function normalize(value) {
      var formatter = __WEBPACK_IMPORTED_MODULE_5_wnumb___default()({
        mark: ',',
        thousand: ' '
      });
      return formatter.to(value);
    },
    toDecimal: function toDecimal(value) {
      return parseFloat(value.replace(',', '.')).toFixed(2);
    }
  },
  mounted: function mounted() {
    var that = this;
    that.target = __WEBPACK_IMPORTED_MODULE_1_sizzle___default()('.download')[0];
    var element = __WEBPACK_IMPORTED_MODULE_1_sizzle___default()('.progress-bar', that.$el)[0];

    // Use ProgressBar.js library to render a circle progress bar
    that.prg = new __WEBPACK_IMPORTED_MODULE_0_progressbar_js___default.a.Circle(element, {
      strokeWidth: 4,
      color: '#178394',
      // trailColor: '#91f47c',
      text: {
        value: 0,
        className: 'progress-text',
        style: {
          color: '#178394',
          position: 'absolute',
          left: '50%',
          top: '50%',
          width: '80%',
          fontSize: '3.5em',
          padding: 0,
          margin: 0,
          transform: {
            prefix: true,
            value: 'translate(-50%, -50%)'
          }
        }
      },
      svgStyle: {
        display: 'block',
        width: '100%'
      }
    });

    // Initiate odometer inside text area
    that.od = new __WEBPACK_IMPORTED_MODULE_3_odometer___default.a({
      el: that.prg.text,
      value: 0,
      duration: 800,
      format: '( ddd)',
      theme: 'minimal'
    });

    // Create a new div with the word "kr" to explain the number in odometer
    var newEl = document.createElement('div');
    newEl.innerHTML = 'KR';
    newEl.style.fontSize = '0.8em';
    that.od.el.appendChild(newEl);

    // Create a path for the white cover background
    var path = document.createElementNS(that.prg.svg.namespaceURI, 'path');
    path.setAttribute('d', 'M 52,52 m 0,-48 a 48,48 1 1 1 0,96 a 44,44 0 1 1 0,-96');
    path.setAttribute('fill', '#fff');
    path.setAttribute('transform', 'scale(0.96)');

    // Insert the path into the SVG image
    that.prg.svg.insertBefore(path, that.prg.path);

    // Create a slider for mileage
    that.sliders.mileage = __WEBPACK_IMPORTED_MODULE_4_nouislider___default.a.create(__WEBPACK_IMPORTED_MODULE_1_sizzle___default()('#mileage', that.$el)[0], {
      start: that.mileage,
      connect: [true, false],
      step: 500,
      range: {
        min: 500,
        max: 10000
      },
      format: __WEBPACK_IMPORTED_MODULE_5_wnumb___default()({
        decimals: 0
      })
    });

    // On slider update, update the mileage count
    that.sliders.mileage.on('update', function (v) {
      that.mileage = parseInt(v[0]);
      that.animateProgress();
    });

    // Create a slider for price
    that.sliders.price = __WEBPACK_IMPORTED_MODULE_4_nouislider___default.a.create(__WEBPACK_IMPORTED_MODULE_1_sizzle___default()('#price', that.$el)[0], {
      start: that.highestValueOfCompanies,
      connect: [true, false],
      step: 0.01,
      range: {
        min: that.tankaValue,
        max: that.tankaValue + 2
      },
      format: __WEBPACK_IMPORTED_MODULE_5_wnumb___default()({
        decimals: 2
      })
    });

    that.sliders.price.on('update', function (v) {
      that.price = parseFloat(v[0]);
      that.animateProgress();
    });

    // Create a slider for cars
    that.sliders.cars = __WEBPACK_IMPORTED_MODULE_4_nouislider___default.a.create(__WEBPACK_IMPORTED_MODULE_1_sizzle___default()('#cars', that.$el)[0], {
      start: that.cars,
      connect: [true, false],
      step: 1,
      range: {
        min: 1,
        max: 20
      },
      format: __WEBPACK_IMPORTED_MODULE_5_wnumb___default()({
        decimals: 0
      })
    });

    that.sliders.cars.on('update', function (v) {
      that.cars = parseInt(v[0]);
      that.animateProgress();
    });

    if (this.printing) {
      that.animateForPrint();
      return;
    }

    // Create a scroll watcher for an element at the bottom of the progressbar window
    var watcher = __WEBPACK_IMPORTED_MODULE_2_scrollmonitor___default.a.create(__WEBPACK_IMPORTED_MODULE_1_sizzle___default()('.bottom', that.$el)[0]);

    // Function when it enters viewport
    watcher.enterViewport(function () {
      that.animateInitial();
    });

    // When it exists viewport
    watcher.exitViewport(function () {
      that.resetProgress();
    });
  },

  methods: {
    enter: function enter(el, done) {
      __WEBPACK_IMPORTED_MODULE_7_velocity_animate___default()(el, 'slideDown', {
        duration: 200,
        complete: function complete() {
          done();
        }
      });
    },
    leave: function leave(el, done) {
      __WEBPACK_IMPORTED_MODULE_7_velocity_animate___default()(el, 'slideUp', {
        duration: 200,
        complete: function complete() {
          done();
        }
      });
    },
    scrollDown: function scrollDown() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lib_scrollDown__["a" /* default */])(this.target.offsetTop);
    },
    calculateDifference: function calculateDifference() {
      return parseFloat(this.literPriceDifference / 2).toFixed(2);
    },
    animateForPrint: function animateForPrint() {
      setTimeout(function () {
        window.PhantomJSPrinting.readyToRender = true;
      }, 500);
      this.od.options.duration = 10;
      this.prg.animate(this.calculateDifference(), {
        duration: 10
      });
    },
    animateInitial: function animateInitial() {
      // Reset values on enter
      this.price = 0;
      this.cars = 1;
      this.mileage = 2500;
      this.od.update(0);

      // Animate progress
      this.animateProgress();

      // Change price slider option values
      this.sliders.price.options.range.min = this.tankaValue;
      this.sliders.price.set(this.highestValueOfCompanies);
    },
    animateProgress: function animateProgress() {
      var that = this;
      that.prg.animate(that.calculateDifference(), {
        duration: 800
      });

      // Make Odometer wait for 0.5s before it
      clearTimeout(that.timeoutId);
      that.timeoutId = setTimeout(function () {
        that.od.update(that.priceDifference);
      }, 500);
    },
    resetProgress: function resetProgress() {
      this.prg.animate(0, {
        duration: 200
      });
      this.price = 0;
      this.cars = 1;
      this.mileage = 2500;
      this.od.update(0);
    }
  },
  computed: {
    highestProfit: function highestProfit() {
      // return 20000
      return window.Math.ceil((this.highestValueOfCompanies - this.tankaValue) * 10000 * this.cars);
    },
    priceDifference: function priceDifference() {
      return window.Math.ceil((this.highestValueOfCompanies - this.tankaValue) * this.mileage * this.cars * 0.7);
    },
    literPriceDifference: function literPriceDifference() {
      return this.highestValueOfCompanies - this.tankaValue;
    },
    tankaValue: function tankaValue() {
      var that = this;
      var result = 0;
      this.companies.forEach(function (x) {
        if (x.name === 'Tanka') {
          result = x.data[that.type] + x.data.cardDiscount + x.data.invoiceDiscount;
        }
      });

      return parseFloat(result.toFixed(2));
    },

    highestValueOfCompanies: {
      get: function get() {
        var that = this;
        if (that.price !== 0) {
          return that.price;
        }

        var result = 0;
        var tot = void 0;

        this.companies.forEach(function (x) {
          var type = that.type;

          if (type === 'dieselPrice') {
            tot = x.data.dieselPriceList + x.data.cardDiscount + x.data.invoiceDiscount;
          } else {
            tot = x.data.gasPriceList + x.data.cardDiscount + x.data.invoiceDiscount;
          }

          if (tot > 0) {
            result = tot;
          }
        });
        return parseFloat(result.toFixed(2));
      },
      set: function set(value) {
        this.price = value;
      }
    },
    cars: {
      get: function get() {
        return this.savings.cars;
      },
      set: function set(value) {
        this.$emit('updateSavings', {
          name: 'cars',
          value: value
        });
      }
    },
    mileage: {
      get: function get() {
        return this.savings.mileage;
      },
      set: function set(value) {
        this.$emit('updateSavings', {
          name: 'mileage',
          value: value
        });
      }
    },
    price: {
      get: function get() {
        return this.savings.price;
      },
      set: function set(value) {
        this.$emit('updateSavings', {
          name: 'price',
          value: value
        });
      }
    }
  }
});

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(79);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
            return false;
          }
          return true;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_components_app_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_components_app_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98_components_app_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99_vue_awesome_components_Icon_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99_vue_awesome_components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99_vue_awesome_components_Icon_vue__);






































































































__WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_99_vue_awesome_components_Icon_vue___default.a);

var client = new __WEBPACK_IMPORTED_MODULE_97_vue__["a" /* default */]({
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_98_components_app_vue___default.a);
  }
});

// When DOM is loaded, mount Vue instance
document.addEventListener('DOMContentLoaded', function () {
  client.$mount('#client');
});

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 267:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/circlekLarge.2a5cc99a.png";

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/okq8Large.db529cab.png";

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/other.dd635097.png";

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/preemLarge.84d537f4.png";

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/tankaLarge.8a4c01ba.png";

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/screen_desktop.c1887738.png";

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(263)
}
var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(283),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0d067594",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(264)
}
var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(284),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1a0abc9f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(262)
}
var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(282),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-006cd778",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(269)
  __webpack_require__(270)
}
var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(288),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fbd34ba2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(267)
  __webpack_require__(268)
}
var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(287),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8c07b7d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 282:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "date-wrap"
  }, [_c('div', {
    staticClass: "url"
  }, [_vm._v("\n      Drivmedelsguiden.se\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("\n      " + _vm._s(_vm.date) + "\n    ")])]), _vm._v(" "), _c('h1', [_vm._v("Resultat av jämförelse")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ingress"
  }, [_vm._v("\n      Tack för att du använder drivmedelsguiden.se - en tjänst från Volvofinans Bank."), _c('br'), _vm._v("\n      Nedan följer en sammanställning av dina val.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "line"
  })])
}]}

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "calculator",
    class: {
      print: _vm.printing
    }
  }, [(!_vm.printing) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.companies.length > 0 && !_vm.printing) ? _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "contain-rows"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "target"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n            Bensin\n            "), _c('div', {
    staticClass: "radio-toolbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "id": "gas",
      "type": "radio",
      "name": "type",
      "value": "gasPrice"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "gasPrice")
    },
    on: {
      "change": function($event) {
        _vm.type = "gasPrice"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gas"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "target"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n            Diesel\n            "), _c('div', {
    staticClass: "radio-toolbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "id": "diesel",
      "type": "radio",
      "name": "type",
      "value": "dieselPrice"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "dieselPrice")
    },
    on: {
      "change": function($event) {
        _vm.type = "dieselPrice"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "diesel"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mobile-only mobile-header"
  }, [_c('div', {
    staticClass: "first-entry"
  }, [_vm._v("\n          Välj ett bolag för jämförelse\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "column-wrap"
  }, [_c('div', {
    staticClass: "columns checkbox-toolbar"
  }, _vm._l((_vm.companies), function(company) {
    return (company.name !== 'Tanka') ? _c('div', {
      key: company.name,
      staticClass: "column"
    }, [_c('div', {
      staticClass: "image-container"
    }, [(company.name !== 'Other') ? [_c('a', {
      staticClass: "letter-spacing",
      attrs: {
        "href": company.website,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": company.logotype
      }
    })])] : [_c('img', {
      attrs: {
        "src": company.logotype
      }
    })]], 2), _vm._v(" "), _c('div', {
      staticClass: "checkbox",
      class: [_vm.chosenCompanies.includes(company.name) ? 'checked' : ''],
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.fixateOnlyThisTarget(company.name)
        },
        "touchstart": function($event) {
          $event.preventDefault();
          _vm.fixateOnlyThisTarget(company.name)
        }
      }
    })]) : _vm._e()
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return _c('div', {
      key: company.name,
      staticClass: "column",
      class: {
        'mobile-only-no-display': !_vm.chosenCompanies.includes(company.name)
      }
    }, [_c('div', {
      staticClass: "container checkbox-toolbar",
      style: ({
        background: _vm.chosenCompanies.includes(company.name) ? '' : 'transparent'
      })
    }, [_c('div', {
      staticClass: "added-margin-top no-mobile"
    }, [_c('div', {
      staticClass: "checkbox",
      class: [_vm.chosenCompanies.includes(company.name) ? 'checked' : ''],
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.fixateTarget(company.name)
        },
        "touchstart": function($event) {
          $event.preventDefault();
          _vm.fixateTarget(company.name)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "logo-container"
    }, [(company.name !== 'Other') ? [_c('a', {
      staticClass: "letter-spacing",
      attrs: {
        "href": company.website,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": company.logotype
      }
    })])] : [_c('img', {
      attrs: {
        "src": company.logotype
      }
    })]], 2)])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "first-entry"
  }, [_c('transition', [(_vm.showListPris) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n              Listpris är ett förutbestämt pris som gäller för företagskunder. Alla ev. rabatter dras från listpriset.\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container question",
    on: {
      "click": function($event) {
        _vm.showListPris = !_vm.showListPris
      },
      "mouseover": function($event) {
        _vm.showListPris = true
      },
      "mouseleave": function($event) {
        _vm.showListPris = false
      }
    }
  }, [_vm._v("\n            Listpris kr/liter\n            "), _c('icon', {
    staticClass: "icon",
    attrs: {
      "name": "question-circle"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return _c('div', {
      key: company.name,
      staticClass: "column",
      class: {
        'mobile-only-no-display': !_vm.chosenCompanies.includes(company.name)
      }
    }, [_c('div', {
      staticClass: "container",
      style: ({
        background: _vm.chosenCompanies.includes(company.name) ? '' : 'transparent'
      })
    }, [_c('div', {
      staticClass: "input-replacement"
    }, [_vm._v("\n              " + _vm._s(_vm._f("normalize")(company.data[_vm.type + 'List'])) + "\n            ")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return _c('div', {
      key: company.name,
      staticClass: "column",
      class: {
        'mobile-only-no-display': !_vm.chosenCompanies.includes(company.name)
      }
    }, [_c('div', {
      staticClass: "container",
      style: ({
        background: _vm.chosenCompanies.includes(company.name) ? '' : 'transparent'
      })
    }, [_c('input', {
      attrs: {
        "type": "number",
        "step": "0.01"
      },
      domProps: {
        "value": _vm.convertPrice(company.data[_vm.type])
      },
      on: {
        "change": function($event) {
          _vm.$emit('updatePrice', $event, company.name, _vm.type)
        }
      }
    })])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return _c('div', {
      key: company.name,
      staticClass: "column",
      class: {
        'mobile-only-no-display': !_vm.chosenCompanies.includes(company.name)
      }
    }, [_c('div', {
      staticClass: "container",
      style: ({
        background: _vm.chosenCompanies.includes(company.name) ? '' : 'transparent'
      })
    }, [_c('input', {
      attrs: {
        "type": "text",
        "maxlength": "3"
      },
      domProps: {
        "value": _vm.convertDiscount(company.data.cardDiscount)
      },
      on: {
        "keyup": function($event) {
          _vm.$emit('updateDiscount', $event.target.value, 'cardDiscount', company.name)
        }
      }
    })])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return _c('div', {
      key: company.name,
      staticClass: "column",
      class: {
        'mobile-only-no-display': !_vm.chosenCompanies.includes(company.name)
      }
    }, [_c('div', {
      staticClass: "container",
      style: ({
        background: _vm.chosenCompanies.includes(company.name) ? '' : 'transparent'
      })
    }, [_c('input', {
      attrs: {
        "type": "text",
        "maxlength": "3"
      },
      domProps: {
        "value": _vm.convertDiscount(company.data.invoiceDiscount)
      },
      on: {
        "keyup": function($event) {
          _vm.$emit('updateDiscount', $event.target.value, 'invoiceDiscount', company.name)
        }
      }
    })])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(6), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return _c('div', {
      key: company.name,
      staticClass: "column",
      class: {
        'mobile-only-no-display': !_vm.chosenCompanies.includes(company.name)
      }
    }, [_c('div', {
      staticClass: "container",
      style: ({
        background: _vm.chosenCompanies.includes(company.name) ? '' : 'transparent'
      })
    }, [_c('div', {
      staticClass: "input-replacement"
    }, [_vm._v("\n              " + _vm._s(_vm.calculatedDiscounts(company.name)) + "\n            ")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row spacing"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(7), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return _c('div', {
      key: company.name,
      staticClass: "result-column",
      class: {
        'mobile-only-no-display': !_vm.chosenCompanies.includes(company.name)
      }
    }, [_c('div', {
      staticClass: "container"
    }, [_vm._v("\n            " + _vm._s(_vm._f("normalize")(_vm.calculateTotal(company.name))) + "\n          ")])])
  })], 2), _vm._v(" "), (_vm.target) ? _c('div', {
    staticClass: "button-row"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": _vm.scrollDown
    }
  }, [_vm._v("Resultat av jämförelse")])]) : _vm._e()])]) : _c('div', {
    staticClass: "wrap print"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "chosenType"
  }, [_vm._v("Vald drivmedelstyp:")]), _vm._v(" "), (_vm.type === 'dieselPrice') ? [_vm._v("\n        Diesel\n      ")] : [_vm._v("\n        Bensin\n      ")]], 2), _vm._v(" "), _c('table', [_c('tr', [_c('th', [_vm._v("\n          Valda aktörer för jämförelse\n        ")]), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return (_vm.chosenCompanies.includes(company.name)) ? _c('th', {
      key: company.name
    }, [_c('div', {
      class: {
        greyBack: company.name === 'Other'
      }
    }, [_c('img', {
      attrs: {
        "src": company.logotype
      }
    })])]) : _vm._e()
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          Listpris kr/liter\n        ")]), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return (_vm.chosenCompanies.includes(company.name)) ? _c('td', {
      key: company.name
    }, [_vm._v("\n          " + _vm._s(_vm._f("normalize")(company.data[_vm.type + 'List'])) + "\n        ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          Skyltat pris kr/liter\n        ")]), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return (_vm.chosenCompanies.includes(company.name)) ? _c('td', {
      key: company.name
    }, [_vm._v("\n          " + _vm._s(_vm._f("normalize")(company.data[_vm.type])) + "\n        ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          Kortrabatt öre/liter\n        ")]), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return (_vm.chosenCompanies.includes(company.name)) ? _c('td', {
      key: company.name
    }, [_vm._v("\n          " + _vm._s(_vm.convertDiscount(company.data.cardDiscount)) + "\n        ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          Fakturarabatt öre/liter\n        ")]), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return (_vm.chosenCompanies.includes(company.name)) ? _c('td', {
      key: company.name
    }, [_vm._v("\n          " + _vm._s(_vm.convertDiscount(company.data.invoiceDiscount)) + "\n        ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          Besparing öre/liter\n        ")]), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return (_vm.chosenCompanies.includes(company.name)) ? _c('td', {
      key: company.name
    }, [_vm._v("\n          " + _vm._s(_vm.calculatedDiscounts(company.name)) + "\n        ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n          Slutpris kr/liter\n        ")]), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return (_vm.chosenCompanies.includes(company.name)) ? _c('td', {
      key: company.name
    }, [_vm._v("\n          " + _vm._s(_vm._f("normalize")(_vm.calculateTotal(company.name))) + " 5\n        ")]) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.printing) ? _c('img', {
    staticClass: "desktop",
    attrs: {
      "src": __webpack_require__(276)
    }
  }) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('h1', [_vm._v("Jämför drivmedelspriser")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-entry"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n            Drivmedelstyp\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-entry"
  }, [_c('div', {
    staticClass: "container no-mobile"
  }, [_vm._v("\n            Välj två eller fler för att jämföra\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-entry"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n            Skyltat pris kr/liter\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-entry"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n            Kortrabatt öre/liter\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-entry"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n            Fakturarabatt öre/liter\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-entry"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n            Besparing öre/liter\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "first-entry"
  }, [_c('div', {
    staticClass: "container endprice-modifier"
  }, [_vm._v("\n            Slutpris/liter\n          ")])])
}]}

/***/ }),

/***/ 284:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Drivmedelsguiden")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.target) ? _c('div', {
    staticClass: "row button-row"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": _vm.scrollDown
    }
  }, [_vm._v("Jämför priser direkt")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row article-row"
  }, [_c('article', [_vm._v("Här kan du enkelt jämföra aktuella drivmedelspriser mellan olika aktörer och se hur valet påverkar den totala drivmedelskostnaden per år – för en eller flera företagsbilar.")])])
}]}

/***/ }),

/***/ 285:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.clazz,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path) {
    return _c('path', _vm._b({}, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon) {
    return _c('polygon', _vm._b({}, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v("\b\n    "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.icon.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 286:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client",
    class: {
      print: _vm.printing
    }
  }, [(_vm.loaded && !_vm.printing) ? _c('dg-header') : _vm._e(), _vm._v(" "), (_vm.printing) ? _c('dg-print-header') : _vm._e(), _vm._v(" "), (_vm.loaded) ? _c('dg-calculator', {
    attrs: {
      "printing": _vm.printing,
      "companies": _vm.companies,
      "chosenCompanies": _vm.chosenCompanies,
      "type": _vm.type
    },
    on: {
      "updatePrice": _vm.updatePrice,
      "updateType": _vm.updateType,
      "handleCompany": _vm.handleCompany,
      "updateDiscount": _vm.updateDiscount,
      "handleOnlyThisCompany": _vm.handleOnlyThisCompany
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loaded && !_vm.printing) ? _c('dg-result', {
    attrs: {
      "companies": _vm.companies,
      "chosen": _vm.chosenCompanies,
      "type": _vm.type
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loaded) ? _c('dg-savings', {
    attrs: {
      "printing": _vm.printing,
      "companies": _vm.selectedCompanies,
      "type": _vm.type,
      "savings": _vm.savings
    },
    on: {
      "sendToPrinting": _vm.sendToPrinting,
      "updateSavings": _vm.updateSavings
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "savings",
    class: {
      print: _vm.printing
    }
  }, [_c('h1', [_vm._v("Årlig besparing")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("\n      " + _vm._s(_vm.priceDifference) + " "), (_vm.printing) ? _c('br') : _vm._e(), _c('span', [_vm._v("KR")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "slider-row"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._v("Körsträcka per år"), _c('span', [_vm._v(_vm._s(_vm._f("normalize")(_vm.mileage)) + " mil")])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "slider-row"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._v("Drivmedelspris"), _c('span', [_vm._v(_vm._s(_vm._f("toDecimal")(_vm._f("normalize")(_vm.highestValueOfCompanies))) + " kr/liter")])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "slider-row"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._v("Antal fordon"), _c('span', [_vm._v(_vm._s(_vm.cars) + " st")])]), _vm._v(" "), _vm._m(3)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "wrap explanation"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "placeholder",
    class: {
      expanded: _vm.expanded
    },
    on: {
      "click": function($event) {
        _vm.expanded = !_vm.expanded
      }
    }
  }, [_vm._v("\n          Så här har vi räknat "), _c('div', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('transition', {
    on: {
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [(_vm.expanded || _vm.printing) ? _c('div', {
    staticClass: "text"
  }, [_vm._v("\n            Spargeneratorn är baserad på ett fordon som har en medelförbrukning på 0,7 liter/mil (diesel). Uträkningen är baserad på mellanskillnaden mellan den dyraste aktörens pris och Tankas pris. Angivna drivmedelspriser på Drivmedelsguiden är inhämtade från respektive aktörs hemsida.")]) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "button-row"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.$emit('sendToPrinting')
      }
    }
  }, [_vm._v("Spara PDF")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "bottom"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "slider",
    attrs: {
      "id": "mileage"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "slider",
    attrs: {
      "id": "price"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "slider",
    attrs: {
      "id": "cars"
    }
  })])
}]}

/***/ }),

/***/ 288:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "result"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('h2', [_vm._v("Resultat av jämförelse")]), _vm._v(" "), _c('div', {
    staticClass: "contain-rows"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "first-entry"
  }), _vm._v(" "), _vm._l((_vm.companies), function(company, index) {
    return (_vm.chosen.includes(company.name)) ? [(index !== _vm.companies.length) ? _c('div', {
      staticClass: "space"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('div', {
      staticClass: "images"
    }, [_c('img', {
      attrs: {
        "src": company.logotype
      }
    })])])] : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "first-entry"
  }, [_c('div', {
    staticClass: "highest"
  }, [_vm._v("\n            " + _vm._s(_vm._f("normalize")(_vm.highestPrice)) + " kr/liter\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "lowest"
  }, [_vm._v("\n            " + _vm._s(_vm._f("normalize")(_vm.lowestPrice)) + " kr/liter\n          ")])]), _vm._v(" "), _vm._l((_vm.companies), function(company, index) {
    return (_vm.chosen.includes(company.name)) ? [_c('div', {
      staticClass: "space"
    }, _vm._l((5), function(n) {
      return _c('div', {
        staticClass: "space-line"
      })
    })), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('div', {
      staticClass: "chart-column-container"
    }, [_c('div', {
      directives: [{
        name: "scroll",
        rawName: "v-scroll",
        value: ({
          name: company.name
        }),
        expression: "{ name: company.name }"
      }],
      staticClass: "chart-fill",
      style: ({
        background: company.name !== 'Tanka' ? '#75a3b1' : ''
      }),
      attrs: {
        "id": company.name
      }
    }, [_c('div', {
      staticClass: "text"
    }, [_vm._v("\n                  " + _vm._s(_vm.lowValue) + "\n                ")])])])])] : _vm._e()
  })], 2), _vm._v(" "), (_vm.target) ? _c('div', {
    staticClass: "button-row"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": _vm.scrollDown
    }
  }, [_vm._v("Årlig besparing")])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_velocity_animate__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_velocity_animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sizzle__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sizzle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sizzle__);





/* harmony default export */ __webpack_exports__["a"] = (function (offset) {
  __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default()(__WEBPACK_IMPORTED_MODULE_1_sizzle___default()('body')[0], 'scroll', {
    duration: 750,
    offset: offset,
    easing: 'easeOutSine'
  });
});

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(265)
}
var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(285),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[261]);


// WEBPACK FOOTER //
// app.691d7bdf.js